import * as Sentry from '@sentry/react';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface AuthUser {
  id: string;
  email: string;
  username: string;
  chips: number;
}

interface AuthState {
  token: string | null;
  user: AuthUser | null;
}

interface AuthActions {
  setAuth: (auth: { token: string; user: AuthUser }) => void;
  updateUser: (user: Partial<AuthUser>) => void;
  logout: () => void;
}

const initialState: AuthState = {
  token: null,
  user: null,
};

export const useAuthStore = create<AuthState & AuthActions>()(
  persist(
    (set) => ({
      ...initialState,

      setAuth: ({ token, user }) => {
        set({ token, user });
        Sentry.setUser({ id: user.id, username: user.username, email: user.email });
      },

      updateUser: (partial) => {
        set((state) => ({
          user: state.user ? { ...state.user, ...partial } : null,
        }));
      },

      logout: () => {
        set(initialState);
        localStorage.removeItem('auth-storage');
        Sentry.setUser(null);
      },
    }),
    {
      name: 'auth-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
